import { useEffect, useState } from "react";
import { APP_URL } from "@/lib/constants";

const NAMES = [
  "Аида", "Айгерим", "Динара", "Асель", "Жанар", "Мадина", "Сауле", "Айнур",
  "Гульнара", "Камила", "Алия", "Дана", "Аружан", "Инкар", "Томирис", "Жания",
  "Анна", "Мария", "Виктория", "Екатерина", "София", "Карина", "Диана", "Алина",
];

const TIMES = ["только что", "1 мин назад", "2 мин назад", "3 мин назад", "5 мин назад"];

export const SocialProof = () => {
  const [toast, setToast] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let hideTimer;
    let nextTimer;
    let last = -1;

    const show = () => {
      let idx;
      do {
        idx = Math.floor(Math.random() * NAMES.length);
      } while (idx === last);
      last = idx;
      setToast({
        name: NAMES[idx],
        time: TIMES[Math.floor(Math.random() * TIMES.length)],
      });
      setVisible(true);
      hideTimer = setTimeout(() => {
        setVisible(false);
        nextTimer = setTimeout(show, 14000 + Math.random() * 12000);
      }, 6000);
    };

    const first = setTimeout(show, 10000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, []);

  if (!toast) return null;

  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="social-proof-toast"
      className="fixed z-40 left-4 md:left-6 bottom-24 md:bottom-6 flex items-center gap-4 pl-3 pr-6 py-3 rounded-2xl"
      style={{
        background: "rgba(6,4,10,0.94)",
        border: "1px solid rgba(255,171,0,0.3)",
        boxShadow: "0 14px 40px rgba(6,4,10,0.45)",
        backdropFilter: "blur(10px)",
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(16px)",
        pointerEvents: visible ? "auto" : "none",
        transition: "opacity 0.5s ease, transform 0.5s cubic-bezier(0.22, 1, 0.36, 1)",
      }}
    >
      <span
        className="w-11 h-11 rounded-full flex items-center justify-center text-[17px] font-bold shrink-0"
        style={{
          background: "linear-gradient(135deg, #7a4c12, #f5cf6b 60%, #b9822a)",
          color: "#2a1a02",
          border: "2px solid rgba(255,171,0,0.4)",
        }}
      >
        {toast.name[0]}
      </span>
      <span>
        <span className="block text-white text-[14px] font-semibold leading-tight">
          {toast.name} получила доступ в VIP-клуб
        </span>
        <span className="flex items-center gap-2 mt-1 text-[12px]" style={{ color: "rgba(255,255,255,0.5)" }}>
          <span className="proof-dot w-[7px] h-[7px] rounded-full inline-block" style={{ background: "#3ddc84" }} />
          {toast.time} · бонусы начислены
        </span>
      </span>
    </a>
  );
};
